const MAIN_FRAMES = {
  LOG_LOGGING: 'Log - Logging',
  LOG_LIVE_TAIL: 'Log - Live Tail',
  LOG_LOGGING_ALERT_DETAIL: 'Alert Detail - Logging',
  LOG_LIVE_TAIL_ALERT_DETAIL: 'Alert Detail - Live Tail',
  LOG_LOGGING_TREND: 'Log - Logging Trend',
  LOG_DETAIL: 'Log - Detail',
  LOG_DETAILED_ANALYSIS: 'Log - Detailed Analysis',
  LOG_TEMPLATE_ANALYSIS_BY_TARGET: 'Template Analysis by Target',
} as const;

export const LOG_FRAME_NAMES = {
  LOG_LOGGING: {
    FILTERS: `${MAIN_FRAMES.LOG_LOGGING}/Filters`,
    LOGGING_LIST: `${MAIN_FRAMES.LOG_LOGGING}/Logging List`,
    LOGGING_CHART: `${MAIN_FRAMES.LOG_LOGGING}/Logging Chart`,
    LOGGING_PREVIOUS: `${MAIN_FRAMES.LOG_LOGGING}/Logging Previous`,
    LOGGING_KEYWORD: `${MAIN_FRAMES.LOG_LOGGING}/Logging Keyword`,
    LOGGING_KEYWORD_UPDATE: `${MAIN_FRAMES.LOG_LOGGING}/[Update] Logging Keyword`,
    LOGGING_CUSTOM_KEYWORD: `${MAIN_FRAMES.LOG_LOGGING}/Logging Custom Keyword`,
    LOGGING_CUSTOM_KEYWORD_UPDATE: `${MAIN_FRAMES.LOG_LOGGING}/[Update] Logging Custom Keyword`,
    ALERT_COUNT: `${MAIN_FRAMES.LOG_LOGGING}/Alert Count`,
  },
  LOG_LOGGING_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.LOG_LOGGING_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.LOG_LOGGING_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.LOG_LOGGING_ALERT_DETAIL}/Clear System Alert`,
  },
  LOG_LIVE_TAIL: {
    LIVE_TAIL_LIST: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Live Tail List`,
    LIVE_TAIL_LOG_TYPE: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Live Tail Log Type`,
    LIVE_TAIL_TARGET_LIST: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Live Tail Target List`,
    LIVE_TAIL_POD_LIST: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Live Tail Pod List`,
    LIVE_TAIL_WORKLOAD_LIST: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Live Tail Workload List`,
    ALERT_COUNT: `${MAIN_FRAMES.LOG_LIVE_TAIL}/Alert Count`,
  },
  LOG_LIVE_TAIL_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.LOG_LIVE_TAIL_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.LOG_LIVE_TAIL_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.LOG_LIVE_TAIL_ALERT_DETAIL}/Clear System Alert`,
  },
  LOG_LOGGING_TREND: {
    LOGGING_TREND_TARGET: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Targets View`,
    LOGGING_TREND_CHART: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Log Trend`,
    LOGGING_TREND_LIST: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Logging List`,
    LOGGING_TREND_FIELD: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Field List`,
    LOGGING_TREND_KEYWORD: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Keyword List`,
    LOGGING_TREND_KEYWORD_UPDATE: `${MAIN_FRAMES.LOG_LOGGING_TREND}/[Update] Keyword List`,
    LOGGING_TREND_AUTO_COMPLETE: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Auto Complete`,
    LOGGING_TREND_ENABLED: `${MAIN_FRAMES.LOG_LOGGING_TREND}/Enabled`,
  },
  LOG_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.LOG_DETAIL}/Information`,
    MESSAGE: `${MAIN_FRAMES.LOG_DETAIL}/Message`,
    FIELD_LIST: `${MAIN_FRAMES.LOG_DETAIL}/Field List`,
  },
  LOG_DETAILED_ANALYSIS: {
    TOTAL_SIMILAR_TREND: `${MAIN_FRAMES.LOG_DETAILED_ANALYSIS}/Total Similar Trend`,
    TARGET_SIMILAR_TREND: `${MAIN_FRAMES.LOG_DETAILED_ANALYSIS}/Target Similar Trend`,
    SIMILAR_LOG_LIST: `${MAIN_FRAMES.LOG_DETAILED_ANALYSIS}/Similar Log List`,
    TEMPLATE_ANALYSIS_HISTORY: `${MAIN_FRAMES.LOG_DETAILED_ANALYSIS}/Template Analysis History`,
    TEMPLATE_ANALYSIS_LOGGING_LIST: `${MAIN_FRAMES.LOG_DETAILED_ANALYSIS}/Template Analysis Logging List`,
  },
  LOG_TEMPLATE_ANALYSIS_BY_TARGET: {
    OCCURRENCES_BY_TARGET: `${MAIN_FRAMES.LOG_TEMPLATE_ANALYSIS_BY_TARGET}/Occurrences by Target`,
    IDENTICAL_PATTERN_OCCURRENCE_TREND: `${MAIN_FRAMES.LOG_TEMPLATE_ANALYSIS_BY_TARGET}/Identical Pattern Occurrence Trend`,
    LOGGING_LIST: `${MAIN_FRAMES.LOG_TEMPLATE_ANALYSIS_BY_TARGET}/Logging List`,
  },
} as const;
